module.exports = __webpack_public_path__ + "static/mining-pools-f68aa02818d9a8efde2907862031e48e.svg";